export default "__VITE_ASSET__Bp$TIfgn__"